import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

/**
 * Gate for the v2 Manifest and Waste Stream views.
 *
 * The v2 views render only when the `manifest-views-v2` flag is on for the
 * tenant; otherwise the v1 views render. The flag is `staffOverride: true`, so
 * `useFeatureFlags` already resolves it to `true` for staff — staff always get
 * v2 (the discrepancy review tooling lives there). No explicit `isStaff` check
 * is needed here.
 *
 * Returns `true` when the v2 views should render, `false` for the v1 fallback.
 */
export function useManifestViewsV2(): boolean {
  const { featureFlags } = useFeatureFlags();
  return !!featureFlags[FeatureFlagKey.ManifestViewsV2];
}
